import { render } from "./appoinmentList.vue?vue&type=template&id=5a485718&scoped=true"
import script from "./appoinmentList.vue?vue&type=script&lang=js"
export * from "./appoinmentList.vue?vue&type=script&lang=js"

import "./appoinmentList.vue?vue&type=style&index=0&id=5a485718&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a485718"]])

export default __exports__